import axios from "axios";
// import { downloadSlides } from "./apis";
import { Player } from "./videoFunction";

// import FlvJs from "flv.js";
// export class utility {};
//
// //2. For require syntax
// class utility {}
// module.exports.utility = utility
import $ from 'jquery';
import {resetTimer, skipElement} from "./main";

//salva i dati del form in un json nell'archiviazione locale
function saveFile() {
  $("#save").attr("disabled", true);
  var idUser = document.getElementById("idUser");
  var apiToken = document.getElementById("apiToken");
  var videoTerminal = document.getElementById("videoTerminal");
  var apiUrl = document.getElementById("apiUrl");
  var videoVersion = document.getElementById("videoVersion");
  var videoRotation = 0;
  var videoRotation1 = $("#videoRotation");
  var videoRotation2 = $("#videoRotation1");
  var videoRotation3 = $("#videoRotation2");
  var videoRotation4 = $("#videoRotation3");

  if(videoRotation1.is(":checked")){
    videoRotation = 90;
  }else if(videoRotation2.is(":checked")){
    videoRotation = 180;
  }else if(videoRotation3.is(":checked")){
    videoRotation = 270;
  }else if(videoRotation4.is(":checked")){
    videoRotation = 360;
  }


  if(!checkConfigurationForm()){
    var json = {
      apiUrlj: apiUrl.value,
      idUserj: idUser.value,
      apiTokenj: apiToken.value,
      videoVersionj: videoVersion.value,
      videoTerminalj: videoTerminal.value,
      videoRotationj :videoRotation
    };
    const data = JSON.stringify(json);
    try {
      window.localStorage.setItem("jso", data);
    } catch (exception) {
      console.log("save error")
      alert("Saving Error")
    }
    console.log(
      "json dati cofigurazione salvato: " + JSON.parse(window.localStorage.getItem("jso"))
    );
    saveJson("");
    console.log("resettato jsonSlides");
    alert("Configuration saved!");
    location.reload();
  }else{
    alert("Please fill all required fields");
    $("#save").attr("disabled", false);
  }

}

function checkConfigurationForm(){
  var error = false;
  var idUser = document.getElementById("idUser").value;
  var apiToken = document.getElementById("apiToken").value;
  var videoTerminal = document.getElementById("videoTerminal").value;
  // var apiUrl = document.getElementById("apiUrl").value;
  var videoVersion = document.getElementById("videoVersion").value;
  if( !idUser || !apiToken || !videoTerminal || !videoVersion){
    error = true;
  }

  return error;
}

function saveJson(json) {
  const data = JSON.stringify(json);
  window.localStorage.setItem("jsonSlides", data);
}


// var countTimeOut = 0;
function getXml(xmlUrl, responseFiles, phfcli) {
  var config = {
    headers: {
      'Content-Type': 'text/xml',
    }
  };
  axios.get(xmlUrl, config)
    .then(response => {
      var doc = response.data;

      if(doc != null && doc.length > 0){
        const parser = new DOMParser();
        var docX = parser.parseFromString(doc, "text/xml");
        var jsonSlide = {};
        var jsonSlides = new Array();
        var n = docX.getElementsByTagName("slide");
        if(n.length === 0){
          //Non ci sono slide presenti nel file xml
          phfcli.resetStatusOnError();
          return;
        }
        for (let i = 0; i < n.length; i++) {
          var slideX = docX.getElementsByTagName("slide")[i];
          jsonSlide = {
            url: slideX.getAttribute("url"),
            folderFiles: slideX.getAttribute("folderFiles"),
            time: slideX.getAttribute("time"),
            tween: slideX.getAttribute("tween"),
            tweentime: slideX.getAttribute("tweentime"),
            dateFrom: slideX.getAttribute("dateFrom"),
            dateTo: slideX.getAttribute("dateTo"),
            timeFrom: slideX.getAttribute("timeFrom"),
            timeTo: slideX.getAttribute("timeTo"),
            typej: slideX.getAttribute("type"),
            lottie: slideX.getAttribute("lottie"),
            animataOld: slideX.getAttribute("animataOld"),
            href: ""
          }
          jsonSlides.push(jsonSlide);
        }
        saveJson(jsonSlides);

        //poi scorro l'array creato prendendo le slide in ordine e ci associo il giusto link
        var slidesArray = JSON.parse(window.localStorage.getItem("jsonSlides"));
        var tempSlides = new Array();
        if (slidesArray != null) {
          for (const slide of slidesArray) {
            //				console.log("slide attuale: " + slide);
            var slideName = slide.url.replace('/', '\\');

            if(slide.lottie > 0){
              slideName = slideName.replace('phv','json');
            }
            for (const file of responseFiles) {
              var fileN = file.fileName;
              if (fileN.localeCompare(slideName) == 0) {
                //						console.log("slide name: " + slideName);
                var slideHref = file.href;
                var slideHash = file.hash;
                var slideHrefHttps = slideHref.replace("http", "https");
                slide.href = slideHrefHttps;
                slide.hash = slideHash;
                let slideObj = { jsonObj: slide, media: null };
                tempSlides.push(slideObj);
              }
            }
          }
          saveJson(tempSlides);
          phfcli.slides = tempSlides;
          document.getElementById("progress").innerHTML ="0 / " + phfcli.slides.length;

          phfcli.status = 3;
        } else {
          phfcli.resetStatusOnError();
          return;
        }

      }else{
        phfcli.resetStatusOnError();
        return;
      }

    }).catch(error => {
    if(phfcli.debug == 1) {
      console.log(error);
    }
    phfcli.resetStatusOnError();
    return;
  });
}

//metodo che prende il video.xml nella versione preview (quindi da cartella in locale)
function getXmlLocal(xmlUrl, phfcli, percorsoVideoXml) {
  var videoXml = "";
  var options = {
    method: 'GET',
    url: xmlUrl + '?id=' + phfcli.idUnique
  }
  // fetch(xmlUrl)
    axios(options)
    .then( response => response)
    .then(t => {
      videoXml = t;
      if(phfcli.debug == 1) {
        console.log("videoxml" + JSON.stringify(videoXml));
      }
      if(videoXml != null){
        var parser = new DOMParser();
        var docX = parser.parseFromString(videoXml.data, "text/xml");
        var jsonSlide = {};
        var jsonSlides = new Array();
        var xmlSlide = docX.getElementsByTagName("slide");
        if(xmlSlide.length === 0){
          //Non ci sono slide presenti nel file xml
          phfcli.status = 0;
          return;
        }
        for (let i = 0; i < xmlSlide.length; i++) {
          var slideX = docX.getElementsByTagName("slide")[i];
          jsonSlide = {
            url: slideX.getAttribute("url"),
            folderFiles: slideX.getAttribute("folderFiles"),
            time: slideX.getAttribute("time"),
            tween: slideX.getAttribute("tween"),
            tweentime: slideX.getAttribute("tweentime"),
            dateFrom: slideX.getAttribute("dateFrom"),
            dateTo: slideX.getAttribute("dateTo"),
            timeFrom: slideX.getAttribute("timeFrom"),
            timeTo: slideX.getAttribute("timeTo"),
            typej: slideX.getAttribute("type"),
            lottie: slideX.getAttribute("lottie"),
            animataOld: slideX.getAttribute("animataOld"),
            href: ""
          }
          jsonSlides.push(jsonSlide);
        }
        saveJson(jsonSlides);

        //poi scorro l'array creato prendendo le slide in ordine e ci associo il giusto link
        var slidesArray = JSON.parse(window.localStorage.getItem("jsonSlides"));
        var tempSlides = new Array();
        if (slidesArray != null) {
          for (const slide of slidesArray) {
            var slideHrefHttps = percorsoVideoXml + slide.url;
            // var slideHrefHttps = slideHref.replace("http", "https");
            slide.href = slideHrefHttps;
            if(slide.lottie > 0){
              slide.href = slide.href.replace('phv','json');
              slide.url = slide.url.replace('phv','json');
            }
            let slideObj = { jsonObj: slide, media: null };
            tempSlides.push(slideObj);
          }
        }
        saveJson(tempSlides);
        phfcli.slides = tempSlides;
        // document.getElementById("progress").innerHTML ="0 / " + phfcli.slides.length;

        phfcli.status = 3;
      } else {
        phfcli.status = 0;
        return;
      }
    });
}

//resetta il json passato
function resetFile() {
  var js = null;
  window.localStorage.setItem("jso", js);
  location.reload();
}

//funzione per creare un id random, al momento inutilizzata
// function makeid(length) {
//   var result           = '';
//   var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
//   var charactersLength = characters.length;
//   for ( var i = 0; i < length; i++ ) {
//     result += characters.charAt(Math.floor(Math.random() * charactersLength));
//   }
//   return result;
// }

function showSlide(urlToDisplay, addParam, params, type, time) {
  urlToDisplay = urlToDisplay + (urlToDisplay.includes("?") ? "&" : "?") + "id=" + params.idUnique;
  var totalUrl = urlToDisplay;
  var imgVuota = require("@/assets/nero.jpg");
  if(params.mode == 0) {
    if (addParam == true) {
      totalUrl =
        urlToDisplay +
        "&nomeTerminale=" +
        params.VIDEO_TERMINAL +
        "&idUser=" +
        params.ID_USER;
    }
  }else if(params.mode == 1){
    totalUrl = urlToDisplay;
  }
  var loading = document.getElementById("loading");
  if (loading != null) {
    loading.style.display = "none";
  }
  //VIDEO
  if (type == "video") {
    params.firsTimeSlideAnimataOld = -1;
    // Player.stop();
    document.getElementById("divImage").style.display = "none";
    document.getElementById("animation").style.display = "none";

    params.image1 = imgVuota;
    // document.getElementById("divImage").src = "";s
    Player.videoElem.style.display = "";

    Player.prepare(totalUrl, time);
    if(params.debug == 1) {
      console.log("prepare fatto");
    }

  }else if(type == "animation") {
    params.firsTimeSlideAnimataOld = -1;
    document.getElementById("divImage").style.display = "none";
    try{
      //assegna
      params.image1 = imgVuota;
      Player.pause();
      Player.videoElem.style.display = "none";
    }catch(err){
      if(params.debug == 1) {
        console.log("ERROR immagine: " + err);
      }
    }
    this.startAnimation(totalUrl);
    document.getElementById("animation").style.display = "";

  }else {
    if(type == 'animataOld'){
      //serve se ci sono due slide animate vecchie vicine che quindi non fa l'onload dell'immagine
      params.firsTimeSlideAnimataOld= params.firsTimeSlideAnimataOld +1;
      if(params.tipoApp == 2){
        totalUrl =  require("@/assets/slide-non-dispo-43-es.jpg");
      }else{
        totalUrl = require("@/assets/slide-non-dispo-43.jpg");
    }
    }else{
      params.firsTimeSlideAnimataOld = -1;
    }



    //IMMAGINE
    document.getElementById("animation").style.display = "none";
    try{
      //assegna
      params.image1 = imgVuota;
      Player.pause();
      Player.videoElem.style.display = "none";
    }catch(err){
      if(params.debug == 1) {
        console.log("ERROR immagine: " + err);
      }
    }
    try{
      params.image1 = totalUrl;
      document.getElementById("divImage").onerror = function () {
        if(document.getElementById("divImage").style.display != "none" && document.getElementById("divImage").src != null && document.getElementById("divImage").src.length > 0 && !document.getElementById("divImage").src.includes("index.html")){
          skipElement(params);
        }
      };
      document.getElementById("divImage").onload = function () {
        if(params.debug == 1) {
          console.log("entrato nell'onload dell immagine " + document.getElementById("divImage").src);
        }
        if(document.getElementById("divImage").src.indexOf("nero.") <= 0 && document.getElementById("divImage").src != null && document.getElementById("divImage").src.length > 0 && !document.getElementById("divImage").src.includes("index.html")){
          resetTimer(time, params);
        }
      };
      //serve se ci sono due slide animate vecchie vicine che quindi non fa l'onload dell'immagine e devo resettare il timer
      if(params.firsTimeSlideAnimataOld>0 && type == 'animataOld'){
        resetTimer(time, params);

        if(params.debug == 1) {
          console.log("due slide animate vecchie di seguito, resetto il timer manualmente");
        }
      }


    }catch (e) {
      if(params.debug == 1) {
        console.log(params.image1);
      }
    }
    document.getElementById("divImage").style.display = "";
  }

}


function openFullscreen(elem) {
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.mozRequestFullScreen) { /* Firefox */
    elem.mozRequestFullScreen();
  } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) { /* IE/Edge */
    elem.msRequestFullscreen();
  }
  document.getElementById("buttons").style.display = "none";
  document.addEventListener('keydown', reportKeyEvent);
  document.addEventListener('fullscreenchange', exitHandler, false);
  document.addEventListener('mozfullscreenchange', exitHandler, false);
  document.addEventListener('MSFullscreenChange', exitHandler, false);
  document.addEventListener('webkitfullscreenchange', exitHandler, false);
}

//per gestire la chiusura del fullscreen
function exitHandler() {
  var buttons = document.getElementById("buttons");
  document.fullScreenMode = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
  if (document.fullScreenMode) {
    buttons.style.bottom = "0";
    buttons.style.position = "absolute"
  } else {
    buttons.style.bottom = "";
    buttons.style.position = "";
    buttons.style.display = "block";
  }
}

function hideShow(elem) {

  if (elem.style.display === "none") {
    elem.style.display = "block";
  } else {
    elem.style.display = "none";
  }
}

//per mostrare o nascondere i buttons tramite button nascosto
function hideShow2() {
  // var buttons = document.getElementById("buttons");
  var sideNav = document.getElementById("mySidenav");
  // console.log("button nascosto")
  if (sideNav.style.marginLeft == "-320px") {
    sideNav.style.marginLeft = "0px";
  } else {
    sideNav.style.marginLeft = "-320px";
  }
}

//se viene cliccato Ctrl vengono mostrati i buttons
function reportKeyEvent(event) {
  var key = event.key;
  var buttons = document.getElementById("buttons")
  if (key == "Control") {
    hideShow(buttons);
  }
}

function closeFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}

function understandStatus(phfCli) {
  if (phfCli.status == 2 || phfCli.status == 3 || phfCli.status == 4 || phfCli.status == 5 || phfCli.status == 6 ) {
    phfCli.stringStatus = "(Downloading...)"
  } else if (phfCli.status == 0 || phfCli.status == -1) {
    phfCli.stringStatus = "(Up to date)"
  }
}

function autofit(elements){
  for(var i = 0; i < elements.length; i++){
    if(elements[i] && elements[i].canResizeFont){
      elements[i].canResizeFont(true);
    }else if(elements[i] && elements[i].elements != null  && elements[i].elements.length > 0){
      autofit(elements[i].elements);
    }
  }
}


export {
  saveFile,
  getXml,
  resetFile,
  showSlide,
  saveJson,
  openFullscreen,
  closeFullscreen,
  hideShow2,
  understandStatus,
  getXmlLocal,
  autofit
}
